import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'appel.campaign.changed': {
    schema: z.object({
      campaignId: z.uuid(),
      action: z.enum(['created', 'updated', 'selected', 'completed', 'consolidated']),
      count: z.number().int().min(0),
    }),
    journal: { label: fr.campaigns.event, importance: 'normal' },
    realtime: true,
  },
});
